import React, { useState } from 'react';

import { Box, TextField, Autocomplete } from '@mui/material';
import type { DocumentType, ReferenceDocumentTypeFieldProps } from '@/types';

interface ChartReferenceDocumentTypeFieldProps
  extends ReferenceDocumentTypeFieldProps<DocumentType> {}

function ChartReferenceDocumentTypeField({
  options,
  value,
  setValue,
  edit,
}: ChartReferenceDocumentTypeFieldProps): React.JSX.Element {
  const [selected, setSelected] = useState<DocumentType | null>(value);

  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: DocumentType | null,
  ): void => {
    setSelected(newValue);
    setValue(newValue);
  };

  return (
    <Box>
      <Autocomplete
        id='governing-document-types-field'
        options={options}
        value={selected || undefined}
        sx={{ width: '100%' }}
        onChange={handleChange}
        getOptionLabel={(option) => `${option.name}`}
        disableClearable={true}
        disabled={edit}
        renderInput={(params) => (
          <TextField {...params} required label='Governing Document Type' />
        )}
      />
    </Box>
  );
}
export default ChartReferenceDocumentTypeField;
